import { inject as service } from '@ember/service';

import ApplicationAdapter from './application';

import type { Snapshot } from '@ember-data/store';
// eslint-disable-next-line ember/use-ember-data-rfc-395-imports
import type { ModelRegistry } from 'ember-data/model';
import type AuthService from 'later/services/auth';

export default class GramAdapter extends ApplicationAdapter {
  @service declare auth: AuthService;
  urlForFindRecord<K extends keyof ModelRegistry>(id: string, modelName: K, snapshot: Snapshot<K>): string {
    const baseUrl = this.buildURL(modelName, id, snapshot);
    if (this.auth.currentAccount?.canAccessPostTagging) {
      return `${baseUrl}?include_tags=true`;
    }
    return baseUrl;
  }
}
